var map = {
	"./blockquote-left.svg": 2362,
	"./card-text.svg": 4993,
	"./check2-square.svg": 5618,
	"./check2.svg": 4634,
	"./clipboard-check.svg": 3645,
	"./eye-fill.svg": 8446,
	"./graph-up.svg": 8410,
	"./key.svg": 204,
	"./list-task.svg": 3066,
	"./newspaper.svg": 2880,
	"./patch-check.svg": 4566,
	"./pencil-square.svg": 572,
	"./people.svg": 9912,
	"./person-check.svg": 9377,
	"./person.svg": 1884,
	"./speedometer2.svg": 8430,
	"./stars.svg": 6911,
	"./trash.svg": 9916,
	"./x-lg.svg": 5647,
	"./x-square.svg": 4022
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 968;